import { getCookie, setCookie } from "./utils";

(function () {
    "use strict";

    const initPopups = () => {
        const popupElements = document.querySelectorAll(".negarshop-popup-element");

        popupElements.forEach(el => {
            const popupId = el.getAttribute("data-popup-id");
            if (!popupId) return;

            // Check cookie
            const cookieName = `negarshop_popup_closed_${popupId}`;
            if (getCookie(cookieName)) {
                return; // User closed it and cookie has not expired yet
            }

            const componentType = el.getAttribute("data-component-type") || "modal";
            const triggerType = el.getAttribute("data-trigger-type") || "onload";
            const cookieExpiry = parseInt(el.getAttribute("data-cookie-expiry") || "0", 10);

            // Create Bootstrap Instance
            let bsInstance;
            if (componentType === "modal") {
                if (typeof bootstrap !== "undefined" && bootstrap.Modal) {
                    bsInstance = new bootstrap.Modal(el);
                }
            } else {
                if (typeof bootstrap !== "undefined" && bootstrap.Offcanvas) {
                    bsInstance = new bootstrap.Offcanvas(el);
                }
            }

            if (!bsInstance) return;

            // Handle Cookie setting on close
            const handleClose = () => {
                if (cookieExpiry > 0) {
                    setCookie(cookieName, "1", cookieExpiry);
                }
            };

            if (componentType === "modal") {
                el.addEventListener("hidden.bs.modal", handleClose);
            } else {
                el.addEventListener("hidden.bs.offcanvas", handleClose);
            }

            const showPopup = () => {
                bsInstance.show();
            };

            // Set up triggers
            if (triggerType === "onload") {
                const delay = parseInt(el.getAttribute("data-trigger-delay") || "0", 10) * 1000;
                setTimeout(showPopup, delay);
            } else if (triggerType === "scroll") {
                const triggerScroll = el.getAttribute("data-trigger-scroll") || "50";

                const onScroll = () => {
                    let shouldTrigger = false;

                    // Check if numeric (percentage) or selector
                    if (!isNaN(triggerScroll)) {
                        const percent = parseInt(triggerScroll, 10);
                        const scrollTop = window.scrollY || document.documentElement.scrollTop;
                        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
                        const currentPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
                        if (currentPercent >= percent) {
                            shouldTrigger = true;
                        }
                    } else {
                        // Selector
                        try {
                            const target = document.querySelector(triggerScroll);
                            if (target) {
                                const rect = target.getBoundingClientRect();
                                if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                                    shouldTrigger = true;
                                }
                            }
                        } catch (e) {
                            // Invalid selector
                        }
                    }

                    if (shouldTrigger) {
                        window.removeEventListener("scroll", onScroll);
                        showPopup();
                    }
                };

                window.addEventListener("scroll", onScroll);
                // Call once in case they are already scrolled past
                onScroll();
            } else if (triggerType === "exit_intent") {
                const onMouseLeave = (e) => {
                    if (e.clientY < 0) {
                        document.removeEventListener("mouseleave", onMouseLeave);
                        showPopup();
                    }
                };
                document.addEventListener("mouseleave", onMouseLeave);
            } else if (triggerType === "click") {
                const selector = el.getAttribute("data-trigger-selector");
                if (selector) {
                    const clickTargets = document.querySelectorAll(selector);
                    clickTargets.forEach(target => {
                        target.addEventListener("click", (e) => {
                            e.preventDefault();
                            showPopup();
                        });
                    });
                }
            }
        });
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initPopups);
    } else {
        initPopups();
    }
})();
